import { Navigate, useLocation } from 'react-router-dom';
import { useOrg } from '../components/OrgContext';
import { newTodayPath, parseNeedsFilter } from '../lib/needsToday';
import { homeKindFor } from './company';

// What /cases shows (redesign step 3; dev website only, App.tsx calls this only when the release switch is on):
//   - a pure agent (the same rule as the agent Home) gets the new Cases hub;
//   - everyone else keeps today's Cases page, unchanged;
//   - an old link /cases?needs=<row> (Home's rows used to open it) sends a pure agent to the new "New today" list of that row;
//     the same link with scope=open (every open case of the type) has no new page yet and shows the hub.
export default function CasesEntry({ hub, legacy }) {
  const { capabilities } = useOrg();
  const { search } = useLocation();
  if (homeKindFor(capabilities) !== 'agent') return legacy;
  const needs = parseNeedsFilter(search);
  if (needs && needs.scope === 'today') return <Navigate to={newTodayPath(needs.row)} replace />;
  return hub;
}
